import { Optional } from 'utility-types'
import { GigyaRequest } from '../RequestFactory.js'
import { AuthRequestSigner, isCredentials, UserKeyCredentials } from './AuthRequestSigner.js'

export interface RSACredentials extends UserKeyCredentials {
	privateKey: string
}

export function isRSACreds(credentials: RSACredentials | any): credentials is RSACredentials {
	return !!credentials.privateKey && isCredentials(credentials)
}

type RequestParams = Optional<RSACredentials, 'userKey' | 'privateKey'>
type RequestType = GigyaRequest<RequestParams>

export class AuthBearerSigner extends AuthRequestSigner<RSACredentials> {
	constructor(creds: RSACredentials) {
		super(creds)
	}

	public sign(request: RequestType) {
		const jwt = this.signJwt(this._creds)
		request.headers.Authorization = `Bearer ${jwt}`

		delete request.params.userKey as any
		delete request.params.privateKey
	}

	private async signJwt(creds: RSACredentials) {
	}
}
